import React, { useContext } from 'react'
import { useLocation } from 'react-router-dom'

import { AuthSessionContext } from '@context/AuthContext'

import { useWindowResize } from '@utils/domUtils'
import { isSignUpPath } from '@utils/path'

import { DesktopNav } from './DesktopNav/DesktopNav'
import { MobileNav as MobileNavView } from './MobileNav/MobileNav'

export const Nav = React.memo(() => {
  const location = useLocation()
  const isMobile = useWindowResize()

  const [auth] = useContext(AuthSessionContext)

  const isSignUp = isSignUpPath(location.pathname)
  const isTwoFactorConfirmPage = location.pathname.includes('/2fa/confirm')
  const isAuthed = !!auth && !(isSignUp || isTwoFactorConfirmPage)

  const navProps = {
    isAuthed,
  }

  if (isMobile) {
    return <MobileNavView {...navProps} />
  }

  return <DesktopNav {...navProps} />
})
